import { Api } from "@/api";
import { B2cProductSearchPayload, Pagination, ProductsSearchDocument } from "@/generated/graphql.lazy/b2c";
import { Context } from "@/services/context.ts";

export const SEARCH_LISTENER_NAME = "search";

export class Search {
  searchString = "";
  loading = true;
  products: B2cProductSearchPayload[] = [];
  pagination: Pagination | null = null;

  constructor(
    protected context: Context,
    protected api: Api,
  ) {
  }

  private update = () => {
    this.context.notify(SEARCH_LISTENER_NAME);
  };

  search = (query: string) => {
    this.loading = true;
    this.searchString = query;
    this.update();
    this.fetchProducts();
  };

  fetchProducts = async () => {
    try {
      const response = await this.api.client.query({
        query: ProductsSearchDocument,
        variables: { input: { query: this.searchString } },
      });
      if (response) {
        //@ts-ignore
        this.products = response.data.ProductsSearch.records;
        this.pagination = response.data.ProductsSearch.pagination;
      }
    } catch (e) {
      console.log("error fetching products", e);
      throw e;
    }

    this.loading = false;
    this.update();
  };
}
